import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=030d2e77&scoped=true"
import script from "./pane.vue?vue&type=script&lang=js"
export * from "./pane.vue?vue&type=script&lang=js"
import style0 from "./pane.vue?vue&type=style&index=0&id=030d2e77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d2e77",
  null
  
)

export default component.exports